import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { map } from 'lodash';
import { FormGroup, Label } from 'reactstrap';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

const SelectFormGroup = ({ input, label, description, placeholder, options, className, onChange,
  disabled, inputClassName, meta: { touched, error },
}) => (
  <FormGroup className={cn({ 'has-error': touched && error }, className)}>
    <Label htmlFor={label}>{label}</Label>
    {description}
    <SelectField
      {...input}
      fullWidth
      floatingLabelText={placeholder}
      className={inputClassName}
      disabled={disabled}
      onChange={(event, index, value) => {
        input.onChange(value);
        if (onChange) { onChange(event, index, value); }
      }}
      errorText={touched && error}
    >
      {map(options, (option, i) => (
        <MenuItem key={i} value={option.value} primaryText={option.label} />
      ))}
    </SelectField>
  </FormGroup>
);

SelectFormGroup.propTypes = {
  input: PropTypes.object,
  label: PropTypes.string,
  description: PropTypes.node,
  meta: PropTypes.object,
  placeholder: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.oneOfType([
      PropTypes.string.isRequired,
      PropTypes.number.isRequired,
    ]),
    label: PropTypes.string.isRequired,
  })),
  onChange: PropTypes.func,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  inputClassName: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
};

export default SelectFormGroup;



// WEBPACK FOOTER //
// ./src/components/Forms/SelectFormGroup.js